var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-skeleton',{staticClass:"w-100",attrs:{"animated":""}},[_c('template',{slot:"template"},[_c('div',{class:_vm.isCardView ? 'd-grid gap-1' : 'd-flex flex-wrap w-100'},_vm._l((_vm.buttons),function(index){return _c('div',{key:index,class:{
          'horizontal-button me-2': _vm.isHorizontal,
          'w-100': _vm.isVertical,
        }},[_c('el-skeleton-item',{staticClass:"skeleton-button w-100 mb-1",attrs:{"variant":"button"}})],1)}),0)])],2)}
var staticRenderFns = []

export { render, staticRenderFns }